var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateUsingAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F6E6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 38.5C40.5833 38.5 36 43.0833 36 53.5C36 43.0833 31.4167 38.5 21 38.5C31.4167 38.5 36 33.9167 36 23.5C36 33.9167 40.5833 38.5 51 38.5Z",
    stroke: "#744C85",
    strokeWidth: 4,
    fill: "#F6E6FB",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 25.5C20.8333 25.5 19 27.3333 19 31.5C19 27.3333 17.1667 25.5 13 25.5C17.1667 25.5 19 23.6667 19 19.5C19 23.6667 20.8333 25.5 25 25.5Z",
    stroke: "#744C85",
    fill: "#F6E6FB",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 15.5C30.2222 15.5 29 16.7222 29 19.5C29 16.7222 27.7778 15.5 25 15.5C27.7778 15.5 29 14.2778 29 11.5C29 14.2778 30.2222 15.5 33 15.5Z",
    stroke: "#744C85",
    fill: "#F6E6FB",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateUsingAiIcon);
export default __webpack_public_path__ + "static/media/createUsingAIIcon.214e6d174981e235716e76f32dcca9e8.svg";
export { ForwardRef as ReactComponent };